var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"concealed-link",attrs:{"to":{ name: 'repo-detail', params: { id: _vm.repo.id } }}},[_c('span',{staticClass:"repo-name",attrs:{"title":'Repo-ID: ' + _vm.repo.id}},[_vm._v(_vm._s(_vm.repo.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }